module.exports = __webpack_public_path__ + "media/images/main-bg-p-1600-af824d2a24f7ae2e7382d2dcb69eb4c8.jpeg";